var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86724 0.214335L9.08645 7.06244C9.18046 7.21582 9.17146 7.41218 9.06045 7.55578C8.55943 8.2064 8.0514 8.78766 7.62438 9.17549C7.62438 9.17549 7.28236 9.50959 7.06535 9.65418C6.76934 9.88766 6.38232 10 6.0063 10C5.58428 10 5.18526 9.87691 4.86624 9.63171C4.80924 9.57602 4.55823 9.36403 4.35322 9.16377C3.07715 7.99539 0.969048 4.94549 0.330016 3.34141C0.227011 3.10793 0.0120006 2.48466 0 2.16131C0 1.84967 0.0680034 1.54879 0.217011 1.25962C0.422021 0.90403 0.740037 0.625612 1.11706 0.469307C1.37907 0.368686 2.16511 0.213358 2.18811 0.213358C2.74914 0.112736 3.53718 0.0375146 4.45722 0.00039219C4.62223 -0.00644615 4.78224 0.0765909 4.86724 0.214335Z",
    fill: "#1B1C21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.13972 0.672276C6.95271 0.370413 7.19173 -0.00960379 7.55074 0.0050498C8.39279 0.0411953 9.13482 0.103717 9.68685 0.179916C9.69885 0.191639 10.6779 0.346967 11.0089 0.525741C11.6239 0.837374 12 1.44892 12 2.10637V2.16108C11.989 2.58506 11.6129 3.48674 11.5899 3.48674C11.4009 3.941 11.0809 4.53399 10.6959 5.1719C10.5219 5.45912 10.0949 5.46595 9.91786 5.17874L7.13972 0.672276Z",
    fill: "#1B1C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowScroll);
export default __webpack_public_path__ + "static/media/arrow-scroll.7bdb50d1a83fe31361db12d2296e8df1.svg";
export { ForwardRef as ReactComponent };